<template>
    <el-card>
        <template #header>
            <content-header />
        </template>
        <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
        >
            <el-tab-pane
                label="收益分析"
                name="first"
            >
                <div class="block">
                    <div class="filters">
                        <el-date-picker
                            v-model="dateBetween"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                        />

                        <el-select
                            v-model="area_id"
                            size="small"
                            placeholder="请选择区域"
                            class="selectwidth"
                        >
                            <el-option
                                v-for="item in put_areas"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                        <div
                            v-if="merchant_id_show"
                            class="div_mch"
                        >
                            <el-select
                                v-model="merchant_id"
                                size="small"
                                placeholder="商户"
                                class="selectwidth"
                            >
                                <el-option
                                    v-for="item in merchant_data.options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                        </div>

                        <el-button @click="SearchData">查询</el-button>
                    </div>
                </div>
                <!-- <div class="filters" display:flex>
                  <span>选择区域：</span>
                  <el-select
                    v-model="area_id"
                    @change="AreaChange"
                    size="small"
                    placeholder="请选择"
                    class="selectwidth"
                  >
                    <el-option
                      v-for="item in put_areas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div> -->
                <p>收益概况</p>
                <div class="gaikuang">
                    <el-card class="min-card">
                        <p>今日新增收益(元)</p>
                        <p class="bolod-p"> {{ todayNewAdd }} </p>
                    </el-card>
                    <el-card class="min-card">
                        <p>本月累计收益(元)</p>
                        <p class="bolod-p"> {{ thisMonthTotal }} </p>
                    </el-card>
                    <el-card class="min-card">
                        <p>总收益(元)</p>
                        <p class="bolod-p"> {{ profitTotal }} </p>
                    </el-card>
                </div>
                <p>收益增长趋势</p>
                <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
                    <line-chart :chart-data="lineChartData" />
                </el-row>
                <el-row>
                    <p>每日收益增长明细
                        <el-button
                            type="info"
                            class="excel-import"
                            style="margin: 0 15px;"
                            @click="exportJishuExcel"
                        >导出技术服务费</el-button>
                        <el-button
                            class="excel-import"
                            type="success"
                            @click="exportExcel"
                        >导出excel</el-button>

                    </p>

                    <div class="excel-import" />

                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        id="table"
                        :row-class-name="tableRowClassName"
                    >
                        <el-table-column label="日期">
                            <template slot-scope="scope">
                                {{ scope.row.date }}
                            </template>
                        </el-table-column>
                        <el-table-column label="新增收益（元）">
                            <template slot-scope="scope">
                                {{ scope.row.profit }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-tab-pane>
            <el-tab-pane
                label="收益明细"
                name="second"
            >
                <search-form
                    ref="searchForm"
                    :fields="search"
                />
                <el-table
                    :data="profitData"
                    style="width: 100%"
                    class="table-font"
                >
                    <el-table-column
                        label="时间"
                        align="center"
                        show-overflow-tooltip
                        min-width="8%"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.created_at }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="手机号"
                        align="center"
                        show-overflow-tooltip
                        min-width="5%"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.mobile }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="支付方式"
                        align="center"
                        show-overflow-tooltip
                        min-width="7%"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.type }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="金额"
                        align="center"
                        show-overflow-tooltip
                        min-width="3%"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.money }}
                        </template>
                    </el-table-column>
                </el-table>
                <div class="card-footer">
                    <pagination :page="page" />
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
import LineChart from "@c/ECharts/LineChart";
import XLSX from "xlsx";
// import { getDepositOrders } from '@/api/deposit'
import { getAreas } from "@/api/area";
import Pagination from "@c/Pagination";
import SearchForm from "@c/SearchForm";
import {
    getProfitStatistics,
    getProfitTotal,
    getProfitOrders
} from "@/api/profit";
import {
    fileDownLoad,
} from "@/api/file";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
    name: "Index",
    components: {
        LineChart,
        Pagination,
        SearchForm
    },
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            dateBetween: "",
            put_areas: [
                {
                    id: "9999",
                    name: "全部"
                }
            ],
            search: [
                {
                    field: "mobile",
                    label: "手机号"
                },
                {
                    type: "el-select",
                    field: "area_id",
                    label: "骑行区域",
                    options: [
                        {
                            id: "",
                            name: "全部"
                        }
                    ]
                }
            ],
            area_id: "9999",
            todayNewAdd: 0,
            thisMonthTotal: 0,
            profitTotal: 0,
            tableData: [],
            profitData: [],
            page: null,
            first_blood: true,
            activeName: "first",
            lineChartData: {
                expectedData: {
                    data: [],
                    date: []
                }
            },
            merchant_data: {},
            merchant_id_show: false,
            merchant_id: null
        };
    },
    mixins: [mixinsAutoPageSize],

    watch: {
        $route: {
            async handler(newVal) {
                await this.autoPageSize(44, newVal);
                const [{ data: profitData }] = await Promise.all([
                    getProfitOrders(newVal.query)
                ]);

                this.profitData = profitData.data;
                this.page = profitData.meta;
            },
            immediate: true
        }
    },
    async created() {
        const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

        this.put_areas.push.apply(this.put_areas, areas);
        this.search[1].options.push.apply(this.search[1].options, areas);

        const [{ data: profitTotal }] = await Promise.all([
            getProfitTotal({ area_id: "9999" })
        ]);
        this.profitTotal = profitTotal;

        const [{ data }] = await Promise.all([
            getProfitStatistics({ area_id: "9999" })
        ]);
        // console.log(data)
        this.todayNewAdd = data.new_add_profit;
        this.thisMonthTotal = data.this_month_total_profit;
        this.tableData = data.profit_statistics;
        // 遍历给折线统计图赋值
        data.profit_statistics.map(i => {
            this.lineChartData.expectedData.data.push(i.profit);
            this.lineChartData.expectedData.date.push(i.date);
        });

        // 反转数据
        this.lineChartData.expectedData.data.reverse();
        this.lineChartData.expectedData.date.reverse();
        if (this.$store.state.users.user.roles[0] === "administrator" && env.isPosSwitch==true) {
            this.merchant_id_show = true;
            this.merchant_data = {
                options: [
                    {
                        id: "",
                        name: "全部"
                    }
                ]
            };
            const [{ data: merchant }] = await Promise.all([
                getAdminUsersMerchant({ all: 1 })
            ]);
            this.merchant_data.options.push.apply(
                this.merchant_data.options,
                merchant.data
            );
        }
        if (this.$store.state.users.user.roles[0] === "administrator") {
            const [{ data: merchant }] = await Promise.all([
                getAdminUsersMerchant({ all: 1 })
            ]);
            if (env.isPosSwitch == true) {
                this.search.push({
                    type: "el-select",
                    field: "merchant_id",
                    label: "商户",
                    options: [
                        {
                            id: "",
                            name: "全部"
                        }
                    ]
                });
                this.search[2].options.push.apply(
                    this.search[2].options,
                    merchant.data
                );
                console.log(this.search,'oooooooooooooooo')
            }
        }
    },
    methods: {
        exportJishuExcel() {
            fileDownLoad({},'profit/exportProfit','get')
        },

        budata(expectedData) {
            if (expectedData.length < 15) {
                expectedData.push(0);
                this.budata(expectedData);
            }
        },
        async SearchData() {
            this.lineChartData.expectedData.data = [];
            this.lineChartData.expectedData.date = [];
            // console.log(this.dateBetween)
            var params = { area_id: this.area_id, merchant_id: this.merchant_id };
            if (this.dateBetween !== null) {
                params = {
                    area_id: this.area_id,
                    dateBetween: this.dateBetween,
                    merchant_id: this.merchant_id
                };
            }

            const [{ data: profitTotal }] = await Promise.all([
                getProfitTotal(params)
            ]);
            this.profitTotal = profitTotal;

            const [{ data }] = await Promise.all([getProfitStatistics(params)]);
            this.todayNewAdd = data.new_add_profit;
            this.thisMonthTotal = data.this_month_total_profit;
            this.tableData = data.profit_statistics;
            data.profit_statistics.map(i => {
                this.lineChartData.expectedData.data.push(i.profit);
                this.lineChartData.expectedData.date.push(i.date);
            });

            this.lineChartData.expectedData.data.reverse();
            this.lineChartData.expectedData.date.reverse();
        },
        handleClick(tab, event) {
            // console.log(tab, event)
            this.$router.push({
                path: this.$route.path + "#"
            });
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex === 1) {
                return "warning-row";
            } else if (rowIndex === 3) {
                return "success-row";
            }
            return "";
        },
        exportExcel() {
            let workbook = XLSX.utils.table_to_book(document.getElementById("table"));
            try {
                XLSX.writeFile(workbook, "profit.xlsx");
            } catch (e) {
                console.log(e, workbook);
                this.$message.error("导出失败请联系管理员");
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.gaikuang {
    display: flex;
    .min-card {
        width: 350px;
        padding: 10px 20px;
        margin: 5px 25px;
        background: rgba(3, 134, 128, 0.1);
        // align-items: center;
        text-align: center;
        font-size: 20px;
        p {
            margin: 10px;
        }
        .bolod-p {
            font-size: 2rem;
        }
    }
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
.table-font {
    font-size: 12px;
}
.filters {
    margin-right: 15px;
    text-align: right;
    margin: 10px;
    .selectwidth {
        padding-left: 30px;
        width: 200px;
        margin-right: 15px;
    }
}
.block {
    margin: 10px 0px;
    display: flex;
    justify-content: space-between;
}
.excel-import {
    float: right;
    margin-bottom: 10px;
}
.div_mch {
    float: left;
    margin-top: 2px;
}
</style>
